import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RequestAPIService } from 'src/app/extensions/services/api/request-api.service';
import { Location } from '@angular/common';
import { DICTIONARY_REQUEST_TYPES, REQUEST_DETAIL_CATEGORY } from 'src/app/extensions/constants/commonConstants';
import { DateInputFillMode, DateInputRounded, DateInputSize } from '@progress/kendo-angular-dateinputs';
import { DictionaryAPIService } from 'src/app/extensions/services/api/dictionary-api.service';
import { GlobalService } from 'src/app/extensions/services/global.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import { DictionaryRequestStatus } from 'src/app/extensions/constants/dictionaryConstants/dictionaryConstants';
import { RequestEvents } from 'src/app/extensions/services/api/events';

@Component({
  selector: 'app-request-detail',
  templateUrl: './request-detail.component.html',
  styleUrls: ['./request-detail.component.scss'],
  standalone: false,
})
export class RequestDetailComponent implements OnInit {
  request: app.models.Requests = {} as app.models.Requests;
  props: app.models.DynamicPropsDictionary;
  statuses: app.models.DictionaryDataModel[];

  documentRequestHeader: app.models.DocumentRequestHeader = {} as app.models.DocumentRequestHeader;
  REQUEST_DETAIL_CATEGORY = REQUEST_DETAIL_CATEGORY;
  selectedCategory: string = REQUEST_DETAIL_CATEGORY.INFO;
  DICTIONARY_REQUEST_TYPES = DICTIONARY_REQUEST_TYPES;

  requestCommentsDataLoaded: boolean = false;
  requestComments: app.models.RequestComment[] = [];
  newComment: string;

  isAdmin: boolean = false;
  requestChangeStatusModel: app.models.RequestChangeStatusModel = {} as app.models.RequestChangeStatusModel;

  public fillModeNone: DateInputFillMode = 'none';
  public roundedLarge: DateInputRounded = 'large';
  public sizeLarge: DateInputSize = 'large';

  public statusId: string = '';
  public dictionaryRequestStatus = DictionaryRequestStatus;

  constructor(
    private _requestAPIService: RequestAPIService,
    private _activatedRoute: ActivatedRoute,
    private _location: Location,
    private _dictionaryAPIService: DictionaryAPIService,
    private _globalService: GlobalService,
    private _notificationService: NotificationService,
    private _translateService: TranslateService,
    private _router: Router
  ) {
    this.selectedCategory =
      this._router.getCurrentNavigation()?.extras.state?.data === REQUEST_DETAIL_CATEGORY.DOCUMENTS
        ? REQUEST_DETAIL_CATEGORY.DOCUMENTS
        : REQUEST_DETAIL_CATEGORY.INFO;
  }

  ngOnInit(): void {
    this.request.requestId = this._activatedRoute.snapshot.params['id'];
    this.isAdmin = this._globalService.isAdminUser();

    if (this.request.requestId) {
      this._requestAPIService.getRequest(this.request.requestId).subscribe(result => {
        this.request = result.data;
        this.props = result.props;
        if (this.request.contractExternalEntityId && this.request.contractItemExternalEntityId) {
          this._requestAPIService
            .getDocumentRequestHeader(this.request.contractExternalEntityId, this.request.contractItemExternalEntityId)
            .subscribe(response => {
              this.documentRequestHeader = response;
            });
        }
        this.statusId = this.request.dictionaryRequestStatus.id.toLowerCase();
        if (this._activatedRoute.snapshot.queryParams['openTab']) {
          this.selectedCategory = this._activatedRoute.snapshot.queryParams['openTab'];
        }
      });
    }

    this.loadData();
  }

  redirectListHandler() {
    this._location.back();
  }

  categoryChangeHandler(selectedCategory: string) {
    this.selectedCategory = selectedCategory;
  }
  loadData() {
    this._dictionaryAPIService.getDictionaryRequestStatuses().subscribe(statusResult => {
      if (statusResult.data) {
        this.statuses = statusResult.data.map(x => ({ ...x, id: x.id.toLowerCase() }));
      }
    });
  }
  changeRequestStatus(statusId: string) {
    const initialStatus = this.request.dictionaryRequestStatus;
    let statusCode = this.statuses.find(x => x.id == statusId).code;
    this.requestChangeStatusModel.requestId = this.request.requestId;
    this.requestChangeStatusModel.dictionaryRequestStatusCode = statusCode;
    this._requestAPIService.changeAssetDocumentRequestStatus(this.requestChangeStatusModel).subscribe(result => {
      if (result.isSuccess) {
        this._notificationService.showSuccess(
          this._translateService.instant('request.statusChange.notifications.requestStatusChanged'),
          this._translateService.instant('common.success')
        );
        let currentStatus = this.statuses.find(
          x =>
            x.id ===
            result.response.events.find(y => y.eventType === RequestEvents.AssetDocumentRequestStatusChanged).eventBody
              ?.dictionaryRequestStatusId
        );
        this.request.dictionaryRequestStatus = currentStatus;
      } else {
        this._notificationService.showError(
          this._translateService.instant('request.statusChange.notifications.requestStatusChangeFailed'),
          this._translateService.instant('common.error')
        );
        this.request.dictionaryRequestStatus = initialStatus;
      }
    });
  }
}
